<template>
  <div class="tile is-justify-content-center m-6">
    <div class="card p-5">
      <div class="is-size-3 has-text-centered my-5">
        <h1>QR Code Generator</h1>
      </div>
      <div>
        <input type="text" class="input is-info" v-model="value" />
      </div>
      <div>
        <button class="button is-info is-fullwidth my-5" @click="generateQRCode">Generate QR Code</button>
      </div>
      <div class="is-flex is-justify-content-center">
        <div id="qrcode"></div>
      </div>
      <div v-show="showQRCode">
        <button class="button is-info is-fullwidth my-5" @click="downloadQRCode">Download</button>
      </div>
    </div>
  </div>
</template>

<script>
/* global QRCode */
export default {
  name: 'offer-statuses-crud',
  data () {
    return {
      value: undefined,
      qrcode: undefined,
      showQRCode: false
    }
  },
  created () {
    this.setQRCodeLibrary()
  },
  methods: {
    setQRCodeLibrary () {
      let head = document.getElementsByTagName('head')[0]
      let script = document.createElement('script')
      script.src = '/qrcode.js'
      head.appendChild(script)
    },
    generateQRCode () {
      this.showQRCode = true
      if (this.qrcode) {
        this.qrcode.clear()
        this.qrcode.makeCode(this.value)
        return
      }
      this.qrcode = new QRCode(document.getElementById('qrcode'), {
        text: this.value,
        width: 256,
        height: 256,
        colorDark: '#000000',
        colorLight: '#ffffff'
      })
    },
    downloadQRCode () {
      let downloadLink = document.createElement('a')
      downloadLink.setAttribute('download', 'qrcode.png')
      document.querySelector('canvas').toBlob(function (blob) {
        let url = URL.createObjectURL(blob)
        downloadLink.setAttribute('href', url)
        downloadLink.click()
      })
    }
  }
}
</script>
